import { AuthenticationContext, adalFetch } from 'react-adal';

const tenant = import.meta.env.VITE_ADAL_TENANT_ID || '26da0e1a-1ace-4d46-8ea5-5da117f08417';
const clientId =
  import.meta.env.VITE_ADAL_APPLICATION_ID || 'dd63d673-8bfd-4779-8bf2-699905f9d8c9';
const apiEndpoint =
  import.meta.env.VITE_ADAL_APPLICATION_ID || 'dd63d673-8bfd-4779-8bf2-699905f9d8c9';

export const adalConfig = {
  tenant,
  clientId,
  endpoints: {
    api: apiEndpoint,
  },
  cacheLocation: 'localStorage',
  redirectUri: window.location.origin,
  popUp: false,
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);
